import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretUp } from '@fortawesome/pro-solid-svg-icons/faCaretUp';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import React from 'react';
import classnames from 'classnames';
import { useIntl } from 'react-intl';

import { Card } from 'ui-components/components/card';
import { Text, TextType } from 'ui-components/components/text';

import messages from './messages';
import style from './style.module.less';
import DataDrivenLogo from '../../../../../../components/data-driven-logo';
import { MarketplaceIds } from '../../../../../../enums/marketplace-ids';

const ShopifyAuthenticatePage = ({ store }) => {
  const [isInfoExpanded, setIsInfoExpanded] = React.useState(false);
  const toggleAdditionalInfo = () => setIsInfoExpanded((prevState) => !prevState);
  const caretIcon = isInfoExpanded ? faCaretUp : faCaretDown;
  const marketplaceName = Object.keys(MarketplaceIds).find((key) => MarketplaceIds[key] === store?.marketplaceId);
  const intl = useIntl();

  return (
    <>
      <DataDrivenLogo className={style.icon} logoType='logo' marketplaceId={store?.marketplaceId} />

      <div className={style.storeLabel}>
        <Text textType={TextType.H4} value={intl.formatMessage(messages.storeLabel, { marketplaceName })} />
        <Text textType={TextType.Paragraph} value={store?.name} />
      </div>

      <Text textType={TextType.H3} value={messages.toReauthenticate} />
      <ol className={style.authenticationSteps}>
        <li>
          <Text textType={TextType.Paragraph} value={messages.toReauthenticateStep1} />
        </li>
        <li>
          <Text textType={TextType.Paragraph} value={messages.toReauthenticateStep2} />
        </li>
      </ol>
      <Text textType={TextType.Paragraph} value={messages.toReauthenticateStep3} />

      <Card className={style.shopifyAdditionalInfoSection}>
        <div
          className={classnames(style.cardHeader, {
            [style.isExpanded]: isInfoExpanded,
          })}
          onClick={toggleAdditionalInfo}
        >
          <Text textType={TextType.H4} value={messages.shopifyAdditionalInfoHeader} />
          <FontAwesomeIcon className={style.caret} icon={caretIcon} />
        </div>

        {isInfoExpanded ? (
          <ul className={style.expandedInformation}>
            <li>
              <Text textType={TextType.Paragraph} value={messages.shopifyAdditionalInfo1} />
            </li>
            <li>
              <Text textType={TextType.Paragraph} value={messages.shopifyAdditionalInfo2} />
            </li>
            <li>
              <Text textType={TextType.Paragraph} value={messages.shopifyAdditionalInfo3} />
            </li>
          </ul>
        ) : null}
      </Card>
    </>
  );
};

export default ShopifyAuthenticatePage;
